import { clipboardSymbol } from '../symbols';
import { clipboard } from '@alilc/lowcode-designer';
export var Clipboard = /*#__PURE__*/function () {
  function Clipboard() {
    this[clipboardSymbol] = void 0;
    this[clipboardSymbol] = clipboard;
  }
  var _proto = Clipboard.prototype;
  _proto.setData = function setData(data) {
    this[clipboardSymbol].setData(data);
  };
  _proto.waitPasteData = function waitPasteData(keyboardEvent, cb) {
    this[clipboardSymbol].waitPasteData(keyboardEvent, cb);
  };
  return Clipboard;
}();